/*
 * Developed by HuMingZhi on 1/20/19 3:04 PM
 * Copyright (c) 2019. All right reserved.
 *
 * 判断是否是生产环境、非生产环境
 */
var mode = process.env.NODE_ENV;
export var isProductionMode = mode === 'production';
